import $ from "jquery";
import {init as initCmsLightbox} from "../../_views/cms_lightbox/cms_lightbox";
import {
    setFooterCloseText,
    setFooterText,
    setHeadline,
    setSubHeadline,
    show as showCmsLightbox
} from "../../_flux/actions/cms_lightbox_actions";

export const initCmsLightboxContainer = () => {
    $('a[href="#open-lightbox"]').on('click', function (event) {
        event.preventDefault();

        initCmsLightbox(document.getElementById('cms-lightbox-container'));
        let totalAttribute = 0;
        $.each($(this).data(), function (i, v) {
            totalAttribute++;
        });

        if (totalAttribute > 0) {
            const data = $(this).data();
            if (typeof data.cmslightbox !== 'undefined' && data.cmslightbox.length > 0) {
                const targetId = 'cms-lightbox_' + data.cmslightbox;
                const contentWrapper = document.querySelector('#' + targetId);
                if (null !== contentWrapper) {
                    const headline = contentWrapper.querySelector('#cms-lightbox_headline');
                    const subHeadline = contentWrapper.querySelector('#cms-lightbox_subHeadline');
                    const footerText = contentWrapper.querySelector('#cms-lightbox_footerText');
                    const footerCloseText = contentWrapper.querySelector('#cms-lightbox_footerCloseText');
                    if (null !== headline
                        && null !== subHeadline
                        && null !== footerText
                        && null !== footerCloseText
                    ) {
                        setHeadline(headline.innerHTML);
                        setSubHeadline(subHeadline.innerHTML);
                        setFooterText(footerText.innerHTML);
                        setFooterCloseText(footerCloseText.innerHTML);
                        showCmsLightbox();
                    }
                }
            }
        }
    });
};